import commonUtil from '@/utils/commonUtil';
import timeUtil from '@/utils/timeUtil';
import apiHelper from '@/utils/apiHelper';
import { API_URL } from '@/constants/api';
import type { App } from 'vue';

export default {
  install(app: App) {
    app.config.globalProperties.$commonUtil = commonUtil;
    app.config.globalProperties.$timeUtil = timeUtil;
    app.config.globalProperties.$apiHelper = apiHelper;
    app.config.globalProperties.$apiUrl = API_URL;
  },
};
